module.exports = function () {
    return {
        restrict: 'AE',
        require: '^bwsAccordionGroup',
        link(scope, element, attrs, ctrl) {

           if (!attrs.$attr.bwsAccordionOpen) {
               element.hide();
           }

           ctrl.toggleBody = function () {
             element.slideToggle('fast');
           };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/accordion/accordion-body.js
 **/